import { t } from 'ember-intl';
import { get } from '@ember/helper';
import {
  HdsTable,
  HdsIcon,
} from '@hashicorp/design-system-components/components';
import { Flex } from 'core/components';
import { rbacRoles, optionForSourceState } from 'core/helpers';

const RolesTable = <template>
  <HdsTable
    @caption={{t "components.iam.service-principals.roles-table.roles"}}
    @valign="middle"
    data-test-iam-service-principals-roles-table
    ...attributes
  >
    <:head as |H|>
      <H.Tr>
        <H.Th @width="193px">
          {{t "components.iam.service-principals.roles-table.role"}}
        </H.Th>
        <H.Th @width="193px">
          {{t "components.iam.service-principals.roles-table.scope"}}
        </H.Th>
        <H.Th>
          {{t "components.iam.service-principals.roles-table.description"}}
        </H.Th>
      </H.Tr>
    </:head>
    <:body as |B|>
      <B.Tr data-test-iam-service-principals-roles-table-role>
        <B.Td
          data-test-iam-service-principals-roles-table-cell-role-id={{@role}}
        >
          {{#if @role}}
            {{get (rbacRoles @role) "label"}}
          {{else}}
            —
          {{/if}}
        </B.Td>
        <B.Td data-test-iam-service-principals-roles-table-cell-scope>
          {{#let (optionForSourceState "resource-type" @type) as |option|}}
            <Flex @alignItems="center" @direction="row" @gap="xs">
              <HdsIcon @name={{option.icon}} @isInline={{true}} />
              <span>{{@scope}}</span>
            </Flex>
          {{/let}}
        </B.Td>
        <B.Td data-test-iam-service-principals-roles-table-cell-description>
          {{#if @role}}
            {{get (rbacRoles @role) "description"}}
          {{else}}
            —
          {{/if}}
        </B.Td>
      </B.Tr>
    </:body>
  </HdsTable>
</template>;

export default RolesTable;
